<template>
    <v-card>
        <v-card-text>
            <!-- Show an error if fetching data fails -->
            <v-alert
                v-if="errorLoadingGoals"
                type="error"
                dismissible
                class="mb-4"
                @input="errorLoadingGoals = null"
            >
                {{ errorLoadingGoals }}
            </v-alert>

            <!-- Display the table of goals if we have any -->
            <v-data-table
                v-if="goals.length"
                :headers="headers"
                :items="goals"
                :items-per-page="5"
                class="mb-4"
                :loading="loadingGoals"
                loading-text="Loading goals..."
                dense
                hide-default-footer
            >
                <template v-slot:item.event="{ item }">
                    <v-chip :color="item.event_color" small>{{ item.event_short_label.toUpperCase() }}</v-chip>
                </template>

                <template v-slot:item.component="{ item }">
                    {{ item.component_label }}
                </template>

                <template v-slot:item.routine_num="{item}">
                    <span v-if="item.routine_num === 'any'">Any</span>
                    <span v-else-if="item.routine_num === 'all'">All</span>
                    <span v-else>{{ item.routine_num }}</span>
                </template>

                <template v-slot:item.value="{ item }">
                    {{ item.value_label }}
                </template>

                <template v-slot:item.is_active="{ item }">
                    <span v-if="item.is_active">Active</span>
                    <span v-else>Off</span>
                </template>

                <template v-slot:item.achieved_at="{ item }">
                    <span v-if="item.achieved_at">
                        {{ item.timestamp('achieved_at').format('MMM D, YYYY') }}
                    </span>
                    <span v-else>&ndash;</span>
                </template>
            </v-data-table>

            <!-- If no goals yet, show a placeholder -->
            <div v-else-if="!loadingGoals" class="mb-4 text-center">
                <em>No goals found.</em>
            </div>

            <!-- The form to create a new goal -->
            <div>
                <athlete-goal-form
                    v-if="showGoalForm"
                    :saving="saving"
                    :error="errorSavingGoal"
                    @error-cleared="errorSavingGoal = null"
                    @save="onSaved"
                />
            </div>

            <div class="text-right">
                <v-btn
                    v-if="!showGoalForm"
                    color="primary"
                    small
                    @click="showGoalForm = !showGoalForm"
                >
                    <v-icon>mdi-plus</v-icon>
                    <span>Add Goal</span>
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import AthleteGoalForm from '@/Components/Goals/AthleteGoalForm.vue'
import AthleteGoal from '@/Models/AthleteGoal.js' // or an axios approach

export default {
    name: 'AthleteGoals',

    components: {
        AthleteGoalForm,
    },

    props: {
        athleteId: {
            type: Number,
            required: true,
        },
    },

    data: () => ({
        // UI states
        showGoalForm: false,
        saving: false,
        errorSavingGoal: null,

        headers: [
            { text: 'Status',    value: 'is_active' },
            { text: 'Event',     value: 'event' },
            { text: 'Routine',   value: 'routine_num' },
            { text: 'Component', value: 'component' },
            { text: 'Value',     value: 'value' },
            { text: 'Achieved',  value: 'achieved_at' },
        ],

        loadingGoals: false,
        errorLoadingGoals: null,
    }),

    computed: {
        goals() {
            return AthleteGoal.all()
        },
    },

    created() {
        this.fetchGoals()
    },

    methods: {
        /**
         * Fetch the goals for this athlete.
         */
        async fetchGoals() {
            this.loadingGoals = true
            this.errorLoadingGoals = null

            try {
                await AthleteGoal.api().get(`/api/athletes/${this.athleteId}/goals`);
            } catch (error) {
                console.log('kljfkldsjfkds');
                console.log(error);
                this.errorLoadingGoals = error.response?.data?.message || error.message
            } finally {
                this.loadingGoals = false
            }
        },

        /**
         * Called when the form is submitted successfully (Save button).
         */
        async onSaved(form) {
            try {
                this.saving = true
                // POST to your Laravel endpoint
                await AthleteGoal.api().post(`/api/athletes/${this.athleteId}/goals`, form)

                // Hide the form
                this.showGoalForm = false

                // Reload the goals to show the new one
                this.fetchGoals()
            } catch (e) {
                // If there's a 422 or any other error, store it
                this.errorSavingGoal = e
            } finally {
                this.saving = false
            }
        },
    },
}
</script>
